var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMyAds = function SvgMyAds(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5294 5.88281C21.8235 5.88281 20.8706 7.57693 21.2588 8.83575L17.0824 13.024C16.7294 12.9181 16.2118 12.9181 15.8588 13.024L12.8588 10.024C13.2588 8.76517 12.3059 7.05928 10.5882 7.05928C8.88235 7.05928 7.91765 8.7534 8.31765 10.024L2.95294 15.3769C1.69412 14.9887 0 15.9416 0 17.6475C0 18.9416 1.05882 20.0005 2.35294 20.0005C4.05882 20.0005 5.01176 18.3063 4.62353 17.0475L9.97647 11.6828C10.3294 11.7887 10.8471 11.7887 11.2 11.6828L14.2 14.6828C13.8 15.9416 14.7529 17.6475 16.4706 17.6475C18.1765 17.6475 19.1412 15.9534 18.7412 14.6828L22.9294 10.5063C24.1882 10.8946 25.8824 9.94164 25.8824 8.23575C25.8824 6.94164 24.8235 5.88281 23.5294 5.88281Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4708 7.05882L17.5767 4.62353L20.0002 3.52941L17.5767 2.43529L16.4708 0L15.3885 2.43529L12.9414 3.52941L15.3885 4.62353L16.4708 7.05882Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94142 9.41165L3.52966 7.05871L5.8826 6.47047L3.52966 5.88224L2.94142 3.5293L2.35319 5.88224L0.000244141 6.47047L2.35319 7.05871L2.94142 9.41165Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMyAds);
export default ForwardRef;